import tppSlice from './tppSlice';

export { default as tppOp } from './operations';

export default tppSlice;
